(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rich-text"] && !Shopify.designMode) return;
  try {
    // CSS media queries cannot use this JavaScript constant; keep the documented 999px boundaries aligned.
  const MOBILE_MEDIA_QUERY = '(max-width: 999px)';
  const TRANSITION_DURATION_PROPERTY = '--mobile-expandable-rich-text-transition-duration';
  const TRANSITION_TIMEOUT_BUFFER_MS = 100;

  if (!customElements.get('mobile-expandable-rich-text')) {
    class MobileExpandableRichText extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-rich-text-fallback') || this.button) {
          return;
        }

        this.container = this.querySelector('[data-rich-text-container]');
        this.content = this.querySelector('[data-rich-text-content]');
        this.button = this.querySelector('[data-rich-text-toggle]');

        if (!this.container || !this.content || !this.button) {
          return;
        }

        this.mobileQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
        this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.scheduleRefresh = this.scheduleRefresh.bind(this);
        const contentRect = this.content.getBoundingClientRect();
        this.contentWidth = contentRect.width;
        this.contentHeight = contentRect.height;

        this.button.addEventListener('click', this.handleToggle);
        this.container.addEventListener('transitionend', this.handleTransitionEnd);
        this.content.addEventListener('load', this.scheduleRefresh, true);

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', this.scheduleRefresh);
        } else {
          this.mobileQuery.addListener(this.scheduleRefresh);
        }

        document.fonts?.addEventListener?.('loadingdone', this.scheduleRefresh);
        document.fonts?.ready?.then(this.scheduleRefresh);

        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.resizeObserver.observe(this.content);
        } else {
          window.addEventListener('resize', this.handleResize);
        }

        if (typeof MutationObserver !== 'undefined') {
          this.mutationObserver = new MutationObserver(this.scheduleRefresh);
          this.mutationObserver.observe(this.content, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true,
          });
        }

        this.refresh();
        this.setAttribute('data-rich-text-ready', '');
      }

      disconnectedCallback() {
        if (!this.button) {
          return;
        }

        this.button.removeEventListener('click', this.handleToggle);
        this.container.removeEventListener('transitionend', this.handleTransitionEnd);
        this.content.removeEventListener('load', this.scheduleRefresh, true);

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.removeEventListener('change', this.scheduleRefresh);
        } else {
          this.mobileQuery.removeListener(this.scheduleRefresh);
        }

        document.fonts?.removeEventListener?.('loadingdone', this.scheduleRefresh);

        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();

        if (!this.resizeObserver) {
          window.removeEventListener('resize', this.handleResize);
        }

        if (this.refreshFrame) {
          cancelAnimationFrame(this.refreshFrame);
        }

        if (this.animationFrame) {
          cancelAnimationFrame(this.animationFrame);
        }

        if (this.transitionTimer) {
          clearTimeout(this.transitionTimer);
        }

        this.button = null;
      }

      handleTransitionEnd(event) {
        if (event.target === this.container && event.propertyName === 'height') {
          this.finishTransition();
        }
      }

      finishTransition() {
        if (this.transitionTimer) {
          clearTimeout(this.transitionTimer);
          this.transitionTimer = null;
        }

        this.removeAttribute('collapsing');
        this.container.style.height = this.hasAttribute('expanded')
          ? ''
          : `${this.collapsedHeight}px`;
        this.isAnimating = false;
        this.scheduleRefresh();
      }

      handleResize() {
        const contentRect = this.content.getBoundingClientRect();

        if (contentRect.width === this.contentWidth && contentRect.height === this.contentHeight) {
          return;
        }

        this.contentWidth = contentRect.width;
        this.contentHeight = contentRect.height;

        if (this.isAnimating) {
          return;
        }

        this.scheduleRefresh();
      }

      handleToggle(event) {
        event.preventDefault?.();

        if (!this.mobileQuery.matches || this.button.hidden) {
          return;
        }

        const expanding = !this.hasAttribute('expanded');
        const currentHeight = this.container.getBoundingClientRect().height;

        if (this.transitionTimer) {
          clearTimeout(this.transitionTimer);
          this.transitionTimer = null;
        }

        this.isAnimating = true;
        this.container.style.height = `${currentHeight}px`;
        void this.container.offsetHeight;

        this.toggleAttribute('collapsing', !expanding);
        this.toggleAttribute('expanded', expanding);
        this.button.setAttribute('aria-expanded', expanding.toString());

        const targetHeight = expanding
          ? this.content.scrollHeight
          : this.collapsedHeight;

        if (this.animationFrame) {
          cancelAnimationFrame(this.animationFrame);
        }

        this.animationFrame = requestAnimationFrame(() => {
          this.container.style.height = `${targetHeight}px`;

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.finishTransition();
          } else {
            this.transitionTimer = setTimeout(() => {
              this.transitionTimer = null;
              this.finishTransition();
            }, this.getTransitionTimeout());
          }

          this.animationFrame = null;
        });
      }

      scheduleRefresh() {
        if (!this.button) {
          return;
        }

        if (this.isAnimating) {
          return;
        }

        if (this.refreshFrame) {
          cancelAnimationFrame(this.refreshFrame);
        }

        this.refreshFrame = requestAnimationFrame(() => {
          this.refresh();
          this.refreshFrame = null;
        });
      }

      getTransitionTimeout() {
        const durationValue = window.getComputedStyle(this.container)
          .getPropertyValue(TRANSITION_DURATION_PROPERTY)
          .trim();
        const duration = parseFloat(durationValue);
        const durationInMilliseconds = durationValue.slice(-2) === 'ms'
          ? duration
          : duration * 1000;

        return (isNaN(durationInMilliseconds) ? 0 : durationInMilliseconds)
          + TRANSITION_TIMEOUT_BUFFER_MS;
      }

      refresh() {
        if (!this.mobileQuery.matches) {
          this.classList.remove('is-mobile-collapsible');
          this.removeAttribute('collapsing');
          this.removeAttribute('expanded');
          this.container.style.height = '';
          this.button.hidden = true;
          this.button.setAttribute('aria-expanded', 'false');
          return;
        }

        const wasExpanded = this.hasAttribute('expanded');

        this.classList.add('is-mobile-collapsible');
        this.removeAttribute('collapsing');
        this.removeAttribute('expanded');
        this.container.style.height = '';

        const collapsedHeight = this.content.getBoundingClientRect().height;
        const fullHeight = this.content.scrollHeight;
        const isOverflowing = fullHeight > collapsedHeight + 1;
        const isExpanded = wasExpanded && isOverflowing;

        this.collapsedHeight = collapsedHeight;

        this.toggleAttribute('expanded', isExpanded);
        this.button.hidden = !isOverflowing;
        this.button.setAttribute('aria-expanded', isExpanded.toString());
        this.container.style.height = isOverflowing && !isExpanded
          ? `${collapsedHeight}px`
          : '';

        const contentRect = this.content.getBoundingClientRect();
        this.contentWidth = contentRect.width;
        this.contentHeight = contentRect.height;
      }
    }

    customElements.define('mobile-expandable-rich-text', MobileExpandableRichText);
  }
  } catch(e) { console.error(e); }
})();

})();
